import styled from '@emotion/styled'

/* The table is taken out of flow (see SuppliersBalanceTableWrapper) so it stops contributing its
   row height to ModuleContent, whose .simplebar-content grows with its content. This box then
   stretches to the space ModuleContent has left, giving the table a definite height to fit into. */
export const OverviewContent = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
  padding-bottom: var(--lumen-padding-24);
  position: relative;
`
